import { COUNTRIES } from 'react-packages/apiSpecification';

export const getCountryFromCountryCode = (
  countryCode: string
): string | undefined => {
  return COUNTRIES.find((country) => country.code === countryCode)?.name;
};
